import { render } from "./pl35fu.vue?vue&type=template&id=15fadf42&scoped=true"
import script from "./pl35fu.vue?vue&type=script&lang=js"
export * from "./pl35fu.vue?vue&type=script&lang=js"

import "./pl35fu.vue?vue&type=style&index=0&id=15fadf42&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fadf42"]])

export default __exports__